import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Reminders from './reminder/reminder';
import NotificationsBox from './notificationsBox/notificationsBox';
import TodayAgenda from './todayAgenda/todayAgenda';
import ReceptionistTasksAlert from './receptionistTasksAlert/receptionistTasksAlert';
// import ReturnAlerts from './returnAlerts/returnAlerts';

function HomeWeb() {
  return (
    <Container fluid className="p-4">
      <ReceptionistTasksAlert />
      <Row>
        <Col xs={12} md={6} className="mb-4">
          <TodayAgenda />
        </Col>
        <Col xs={12} md={6}>
          <NotificationsBox className="mb-4" />
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col xs={12} md={10} lg={12}>
          {/* <div className="mb-4">
            <ReturnAlerts />
          </div> */}
          <div>
            <Reminders />
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default HomeWeb;
